import { useMutation } from '@tanstack/react-query';
import useCustomer from '~/features/commerce-api/hooks/useCustomer';
import { LoyaltyApiError } from '~/lib/data-contract/loyalty';
import { useQueryClient } from '@tanstack/react-query';
import { MutationKeys, QueryKeys, ScopedMutationKeys } from '~/services/loyalty/constants';
import useBasket from '~/features/commerce-api/hooks/useBasket';

export const useRemoveRewardFromBasket = () => {
    const { businessCentralId } = useCustomer();
    const queryClient = useQueryClient();
    const basket = useBasket();

    return useMutation<void, LoyaltyApiError, string>({
        mutationKey: [MutationKeys.REMOVE_REWARD],
        mutationFn: async (barcode) => {
            await basket.removeRewardsPayment({
                memberAccountNo: businessCentralId,
                barcode,
            });
        },

        // scope is to ensure that the mutation runs in serial instead of parallel to
        // ensure full sync between FE and SFCC when adding a bonusReward
        scope: {
            id: ScopedMutationKeys.SCOPED_REWARDS,
        },
        onSuccess: async () => {
            queryClient.invalidateQueries({
                queryKey: [QueryKeys.ACTIVE_MEMBER_REWARDS],
            });
        },
    });
};
